import { createReducer, createActions } from "reduxsauce";

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getUsers: ["key", "userId", "admin"],
  getUsersSuccess: ["data"]
});

export const UsersTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = {
  users: []
};

/* Reducers */

export const getUsersSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  users: action.data
});

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_USERS_SUCCESS]: getUsersSuccess
});



// WEBPACK FOOTER //
// ./src/storeChat/ducks/users.js